import { Injectable } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {CategoryModel} from '../models/category.model';
import {ProductModel} from '../models/product.model';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { BaseService } from '../../base-service/base.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../.../../../environments/environment';
import { ResourceMappingModel } from '../../resource-mapping/models/resource-mapping.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' })
};

@Injectable()
export class ProductCategoryService {

  baseUrl: string = environment.baseUrl;
  apiUri: string = environment.apiUri;
  constructor(private http:HttpClient) {

  }

  // eco rebates
  getRebateDetails(sku: string, zip: string) {
    let url = `https://lghvac.ecorebates.com/api/search/lghvac/productRebateDetails.json?skus=${sku}`;
    if (zip) {
      url += `&zip=${zip}`;
    }
    return this.http.get(url);
  }

 // Start Image Upload

 saveImageSet(formdata: any) {
  const apiURL = `${this.baseUrl}ProductSearch/saveimageset`;
  return this.http.post(apiURL, formdata);
 }

 deleteImageSet(formdata: any) {
  const apiURL = `${this.baseUrl}ProductSearch/deleteimageset`;
  return this.http.post(apiURL, formdata);
 }

 async getImages(Id: string, ismodel: boolean) {
  const apiURL = `${this.baseUrl}ProductSearch/getImages/${Id}/${ismodel}`;
  return await this.http.get(apiURL).toPromise();
 }

 getImagesrealtime(Id: string, ismodel: boolean): Observable<any> {
  const apiURL = `${this.baseUrl}ProductSearch/getImagesrealtime/${Id}/${ismodel}`;
  return this.http.get(apiURL);
}

 // End Image Upload

 // Start Resource Mapping

 getResource(Id: string) {
  const apiURL = `${this.baseUrl}ContentMapping/resource/${Id}`;
  return this.http.get(apiURL);
 }

  getResources() {
    return this.getResourcesByProduct(null, null, null);
  }

 getResourcesByProduct(productTypeId: string | null, category: string | null, productClass: string | null) {
   let apiURL = `${this.baseUrl}Resource`;
   if (productTypeId) {
     apiURL = `${this.baseUrl}ProductSearch/${productTypeId}/resources`;
     if (category) {
       apiURL += `?category=${category}`;
       if (productClass) {
         apiURL += `&addClass=${productClass}`;
       }
     }
   }
  return this.http.get(apiURL);
 }

 getAssignedModels(Id: string) {
  const apiURL = `${this.baseUrl}ContentMapping/resource/${Id}/assignedmodels`;
  return this.http.get(apiURL);
 }

 getUnassignedModels(Id: string) {
  const apiURL = `${this.baseUrl}ContentMapping/resource/${Id}/unassignedmodels`;
  return this.http.get(apiURL);
 }

 assignModelsToResource(id: string, mappings: ResourceMappingModel[]) {
  const apiURL = `${this.baseUrl}ContentMapping/assignmodels/${id}`;
  return this.http.put(apiURL, mappings);
 }

 unassignModelsToResource(id: string, mappings: ResourceMappingModel[]) {
  const apiURL = `${this.baseUrl}ContentMapping/unassignmodels/${id}`;
  return this.http.put(apiURL, mappings);
 }

 // End Resource Mapping

 // Start Search Results

 getSearchResults(key: string, roles: string) {
  const formattedkey = encodeURIComponent(key);
  let apiURL = `${this.baseUrl}ProductSearch/search/${formattedkey}`;
  if (roles) {
    apiURL += '?roles=' + encodeURIComponent(roles);
   }
   var result = this.http.get(apiURL);
   console.log('getContentSearchResults', result);  
   return result;
  }

  getContentSearchResults(key: string, roles: string) {
    const formattedkey = encodeURIComponent(key);    
    let apiURL = `${this.apiUri}Content/Search/?searchstring=${formattedkey}`;
    var result = this.http.get(apiURL);
    return result;
  }
 // End Search Results

 async getCategories(lineId: string) {
  const encLineId = encodeURIComponent(lineId);
  const apiURL = `${this.baseUrl}ProductSearch/classes/${encLineId}`;
  return await this.http.get(apiURL).toPromise();

/* return [
  {id: '1', name: 'Single Zone', selected: true},
  {id: '2', name: 'Multi Zone', selected: false},
  {id: '3', name: 'Controls', selected: false},
  {id: '4', name: 'Accessories', selected: false}
]; */
}

async getProductById(Id: string) {
const apiURL = `${this.baseUrl}ProductSearch/${Id}`;
return await this.http.get(apiURL).toPromise();
}

  async getPartialProductById(Id: string) {
    const apiURL = `${this.baseUrl}ProductSearch/${Id}/partial`;
    return await this.http.get(apiURL).toPromise();
  }

  async getPartialModelById(productId: string, modelId: string) {
    const apiURL = `${this.baseUrl}ProductSearch/${productId}/partial/${modelId}`;
    return await this.http.get(apiURL).toPromise();
  }

async getModelById(Id: string) {
const apiURL = `${this.baseUrl}ProductSearch/model/${Id}`;
return await this.http.get(apiURL).toPromise();
}

  async doesFileExist(url: string): Promise<boolean> {
    return false;
   // try {
    //    //   await this.http.head(url).toPromise();
    //    //   return true;
    //    // } catch(ex) {
    //    //   return false;
    //    // }
  }

  async getProductsByCategory(categoryId: string, className?: string) {
    const encCatId = encodeURIComponent(categoryId);
    let apiURL = `${this.baseUrl}ProductSearch/category/${encCatId}`;
    if (className) {
      apiURL += `?addclass=${className}`;
    }
    return await this.http.get(apiURL).toPromise();
  }

  async getProducts(categoryId: string, lineName: string) {
    const encCatId = encodeURIComponent(categoryId);
    const encLineName = encodeURIComponent(lineName);
    const apiURL = `${this.baseUrl}ProductSearch/class/${encCatId}/line/${encLineName}`;
    return await this.http.get(apiURL).toPromise();
    /* switch (categoryId) {
      case  '1':
        return [
          {
            id: '3',
            title: 'Single Zone 1',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '4',
            title: 'Single Zone 2',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '5',
            title: 'Single Zone 3',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '6',
            title: 'Single Zone 4',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '7',
            title: 'Single Zone 5',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '8',
            title: 'Single Zone 6',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '9',
            title: 'Single Zone 7',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '10',
            title: 'Single Zone 8',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          }
        ];
      case  '2':
      return [
        {
          id: '6',
          title: 'Multi Zone 1',
          type: 'Ceiling Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '7',
          title: 'Multi Zone 2',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '8',
          title: 'Multi Zone 3',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '9',
          title: 'Multi Zone 4',
          type: 'Ceiling Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '7',
          title: 'Multi Zone 5',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '8',
          title: 'Multi Zone 6',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '9',
          title: 'Multi Zone 7',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        },
        {
          id: '10',
          title: 'Multi Zone 8',
          type: 'Wall Mounted',
          description: 'Description',
          imageURL: 'image url'
        }
      ];
      case  '3':
        return [
          {
            id: '9',
            title: 'Controls 1',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '10',
            title: 'Controls 2',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '11',
            title: 'Controls 3',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '9',
            title: 'Controls 4',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '10',
            title: 'Controls 5',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '11',
            title: 'Controls 6',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '9',
            title: 'Controls 7',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '10',
            title: 'Controls 8',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
        ];
      case  '4':
        return [
          {
            id: '12',
            title: 'Accessories 1',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '13',
            title: 'Accessories 2',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '14',
            title: 'Accessories 3',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '12',
            title: 'Accessories 4',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '13',
            title: 'Accessories 5',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '14',
            title: 'Accessories 6',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '12',
            title: 'Accessories 7',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '13',
            title: 'Accessories 8',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          }
        ];
      default :
        return [
          {
            id: '1',
            title: '4-Way Cassette',
            type: 'Ceiling Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '2',
            title: 'Art Cool Mirror',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          },
          {
            id: '3',
            title: 'Meg',
            type: 'Wall Mounted',
            description: 'Description',
            imageURL: 'image url'
          }
        ];
    } */
  }

  cleanLineId(lineId: string): string {
    let returnValue: string = lineId;
    if (lineId.includes('&')) {
       returnValue = lineId.replace('&', '%26');
    }
    if (lineId.includes(' ')) {
     returnValue = lineId.replace(' ', '+');
   }
    return returnValue;
  }

  extractData(res: Response) {
    let body;
    // check if empty, before call json
    if (res.text()) {
        body = res.json();
    }

    // Handle raw false boolean sent from Back End
    if (!body && res['_body'] === 'false') {
        body = false;
    }
    return body === false ? body : body || {};
}

handleError = (error: any) => {
  let errMsg: string;
  if (error instanceof Response) {
      let body: any;
      let err: any;
      if (error.text()) {
          body = error.json();
          err = body.error || JSON.stringify(body);
      } else {
          err = '';
      }
      errMsg = JSON.parse(err).Message ? JSON.parse(err).Message : err; //`${error.status} - ${error.statusText || ""} ${err}`;
      console.error('Error: ', JSON.parse(err).Message);
  } else {
      errMsg = error.message
          ? error.message
          : error.Message ? error.Message : error.toString();
  }

  return Observable.throw(errMsg);
}


}




// WEBPACK FOOTER //
// ./src/app/product-category/services/product-category.service.ts